import {useContext} from 'react'
import {AuthContext} from '../context'
import {Navigate} from 'react-router-dom'
import {getStoredAuthSession} from '../utils/authSession'

export const PublicRoute = ({children}) => {
	const {authState} = useContext(AuthContext)
	const session = getStoredAuthSession()
	const hasValidSession = Boolean(session?.token || (authState?.logged && authState?.token))

	return hasValidSession ? <Navigate to='/HomeNew' replace /> : children
}
